import { render, staticRenderFns } from "./space-catalog.vue?vue&type=template&id=62dd2af1&scoped=true&"
import script from "./space-catalog.vue?vue&type=script&lang=ts&"
export * from "./space-catalog.vue?vue&type=script&lang=ts&"
import style0 from "./space-catalog.vue?vue&type=style&index=0&id=62dd2af1&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dd2af1",
  null
  
)

export default component.exports